/**
 * created by lei lei
 * 人脸识别action
 *
 */
import {applicationName} from "../utils";

let host = "/cm-sites-" + applicationName();
let headers = {
    "Content-Type": 'application/json;charset=UTF-8'
};
let cacheAndcredentials = {cache: 'no-cache', /*credentials: 'include'*/};
const Apis = {
    faceList: host + '/face/list',//获取人脸识别列表
    addPoint: host + '/face/label',//给人物添加姓名
    faceMeta: host + '/face/meta',//人脸初始化是否可初始化
    faceInitialized: host + '/face/initialized',//人脸初始化
    initProgress: host + '/face/initialized/progress',//人脸初始化进度条
};

//获取媒体列表
export function getFaceList(labeled, page, page_size, callBack) {
    let url = Apis.faceList + '?labeled=' + labeled + '&page=' + page + '&page_size=' + page_size;
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:getFaceList", error);
        callBack([]);
    })
}

//打标签
export function addFace(body, callBack) {
    let url = Apis.addPoint;
    fetch(url, {
        method: 'post',
        body: body,
        headers: headers,
        ...cacheAndcredentials,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:addFace", error);
        callBack([]);
    })
}

//人脸是否可初始化
export function initFaceMeta(callBack) {
    let url = Apis.faceMeta;
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:initFaceMeta", error);
        callBack([]);
    })
}

//人脸初始化
export function faceInitialized(callBack) {
    let url = Apis.faceInitialized;
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:faceInitialized", error);
        callBack([]);
    })
}

//人脸初始化进度条
export function initProgress(callBack) {
    let url = Apis.initProgress;
    fetch(url, {
        method: 'get',
        ...cacheAndcredentials,
    }).then(response => response.json()).then(data => {
        callBack(data);
    }).catch((error) => {
        console.error("actionError:initProgress", error);
        callBack([]);
    })
}